import { usePaymentModalStore } from './modal.store'

export function cardsSelectId(cardId: string) {
  const store = usePaymentModalStore()
  store.cardSelect(cardId)
}
